import React, { useEffect, useState, useCallback } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { max } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../shared/components/SmallLoader';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import {
    getPromotionByRevenueData,
    handleTableLoader
}
    from '../../../redux/actions/PromotionByRevenueAction';
import { months } from '../CompareMonth/helper';
import { findMonthsBetweenDates } from '../../../utils/helpers';
import { tablePromotionByRevenue } from '../helper';
import PromotionTable from './PromotionTable';
import PromotionBar from './PromotionBar';
import ViewSalesReportModal from '../SalesCategoryByDay/ViewSalesReportModal';

const PromotionByRevenue = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');
    const location = useLocation();

    const fromcurrentYear = moment().format('YYYY');
    const tocurrentYear = moment().format('YYYY');
    const fromCurrentMonth = moment().format('MMM');
    const toCurrentMonth = moment().format('MMM');

    const { promotionData, salesChannelFilterData, isTableLoading } = useSelector(
        ({ promotionByRevenueReducer, marketPlaceReducer }) =>
        ({
            promotionData: promotionByRevenueReducer.promotionData,
            isTableLoading: promotionByRevenueReducer.isTableLoading,
            salesChannelFilterData: marketPlaceReducer.salesChannel,

        })
    );

    const [dataToShow, setDataToShow] = useState(promotionData?.modal?.data?.[0]?.dailyPromotionRevenueDTO)
    const [isOpen, setIsOpen] = useState(false);
    const [filterData, setFilterData] = useState({});
    // const [currentlyShow, setCurrentlyShow] = useState(filterShowWiseWithoutCollection?.[0]);
    const [maxValueObj, setMaxValueObj] = useState({});
    const [month2, setMonth2] = useState({ year: tocurrentYear, month: toCurrentMonth });
    const [month1, setMonth1] = useState({ year: fromcurrentYear, month: fromCurrentMonth });
    const [tempMonth2, setTempMonth2] = useState({ year: tocurrentYear, month: fromCurrentMonth });
    const [tempMonth1, setTempMonth1] = useState({ year: fromcurrentYear, month: fromCurrentMonth });
    const [date1, setDate1] = useState(`${month1?.year}-${month1?.month}`);
    const [date2, setDate2] = useState(`${month2?.year}-${month2?.month}`);
    const [selectedCountryOptions, setSelectedCountryOptions] = useState([]);

    const yearOptions = [];
    for (let year = 2016; year <= fromcurrentYear; year += 1) {
        yearOptions.push({ label: year, value: year })
    }

    // const monthOptions = monthsWithValue.map(item => ({ label: item, value: item }));
    const maxValue = max(Object.values(maxValueObj)) || 0;

    const countryCodeOptions = [];
    const callApi = () => {
        dispatch(handleTableLoader(true));
        dispatch(getPromotionByRevenueData({
            fromYear: tempMonth1?.year,
            toYear: tempMonth2?.year,
            fromMonth: moment().month(tempMonth1?.month).format('M'),
            toMonth: moment().month(tempMonth2?.month).format('M'),
        }));
    }
    // eslint-disable-next-line array-callback-return
    promotionData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
        data.filterData.forEach((element) => {
            countryCodeOptions.push({
                value: element.key,
                label: element.shortValue
            });
        });
    });

    const monthOptions = months.map(item => ({ label: item, value: item }));

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
                flag = false
            }
        }

        return flag
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    dvTb.style.display = "none";  
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Promotion By Revenue Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
  }

    const handleApplyDate = () => {
        const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
        const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

        const monthsBetween = findMonthsBetweenDates(startDate, endDate);
        if (monthsBetween?.length > 0 && monthsBetween?.length <= 12) {
            setDate1(`${tempMonth1?.year}-${tempMonth1?.month}`);
            setDate2(`${tempMonth2?.year}-${tempMonth2?.month}`);
            setMonth1(tempMonth1);
            setMonth2(tempMonth2);
            setMaxValueObj({})
            callApi();
        } else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'Please select maximum one year data'
                });
            });
        }
    }

    const handleYearMonthChange = ({ isFrom, field, value }) => {

        if (isFrom) {
            setTempMonth1({ ...tempMonth1, [field]: value?.value });
        } else {
            setTempMonth2({ ...tempMonth2, [field]: value?.value })
        }
    }

    const setMaxValue = useCallback((val) => {
        if (!maxValueObj[val]) {
            setMaxValueObj({ ...maxValueObj, [val]: Number(val) })
        }
    }, [maxValueObj])

    const getMonths = (start, end) =>
        Array.from({ length: end.diff(start, 'month') + 1 }).map((_, index) =>
            moment(start).add(index, 'month').format('MMM-YYYY'));

    const selectedFromMonth = month1.month;
    const selectedFromYear = month1.year;
    const selectedToMonth = month2.month;
    const selectedToYear = month2.year;

    const selectFromDate = selectedFromMonth + selectedFromYear;
    const selectToDate = selectedToMonth + selectedToYear;
    const selectedMonths = getMonths(moment(selectFromDate, 'MMMYYYY'), moment(selectToDate, 'MMMYYYY'))
    // eslint-disable-next-line react/prop-types
    const RenderYearAndMonth = ({ isFrom }) => (
        <Col sm="12" md="4">
            <Row className="justify-content-space-between">
                <Col md="5" sm="6">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Year</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                                    : { value: tempMonth2?.year, label: tempMonth2?.year }}
                                options={yearOptions}
                                clearable={false}
                                placeholder="Select Year"
                                className="select_filter-80"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'from' : 'to'}
                            />
                        </div>

                    </div>
                </Col>
                <Col md="5" sm="6">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Month</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                                    : { value: tempMonth2?.month, label: tempMonth2?.month }}
                                options={monthOptions}
                                clearable={false}
                                placeholder="Select Month"
                                className="select_filter-80"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'fromMonth' : 'toMonth'}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        </Col>
    );

    const changeFilterForCountry = (value) => {
        setSelectedCountryOptions(value)
    };

    useEffect(() => {
        dispatch(handleTableLoader(true));
        callApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setDataToShow(promotionData?.modal?.data?.[0]?.dailyPromotionRevenueDTO);
    }, [promotionData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])

    console.log(dataToShow)
    let dataToShowForDatesSelected = [];    
    const monthsBetweenDates = findMonthsBetweenDates(date1, date2);    
    // for (let i = 0; i < monthsBetweenDates.length; i += 1) {
    //     const [year, month] = monthsBetweenDates?.[i]?.split('-');
    //     let monthWiseData = dataToShow ?? [];
    //     if (monthWiseData) {
    //         monthWiseData = monthWiseData.filter(item =>
    //             filterBasedOnFilter(item))?.map(item => ({
    //                 ...item,
    //                 // salesMonth: month,
    //                 // salesYear: year
    //             }))
    //         dataToShowForDatesSelected = dataToShowForDatesSelected?.concat(monthWiseData);

    //     }
    // }

    dataToShowForDatesSelected = dataToShow?.filter(item =>
                    filterBasedOnFilter(item)) ?? [];

    if (selectedCountryOptions?.length) {
        const selected = selectedCountryOptions?.reduce((acc, item) => {
            acc[item?.value] = item.value
            return acc
        }, {})
        dataToShowForDatesSelected = dataToShowForDatesSelected.filter(item => selected[item.countryCode])
    }

    return (
        <Container className="dashboard">
            <Row className="category-sales">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">Promotion By Revenue</h5>
                            </div>
                            <Row 
                            className="justify-content-space-between 
                            align-items-center">                                
                                <Col sm="12" md="9">
                                    <Row className="justify-content-right align-items-center ">
                                        <RenderYearAndMonth isFrom />
                                        <Col sm='1' className="filter-to-position">~</Col>
                                        <RenderYearAndMonth />
                                        <Col sm="3" className="p-0 filter-to-position">
                                            <button className="btn btn-sm btn-primary
                                             apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isTableLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>                                       
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
            <Card className="pb-3">
                <CardBody className="">
                    <Row className="show-sales-region">
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="top-location" style={{ minHeight: '400' }}>
                                        <div className="card__title row align-items-center">
                                            <h5 className="bold-text col-md-4">Promotion By Revenue</h5>
                                        </div>
                                        <div >
                                            {isTableLoading ? <div style={{ minHeight: '200px' }}
                                                className="row align-items-center justify-content-center">
                                                <SmallLoader loading={isTableLoading} />
                                            </div>
                                                : <PromotionBar month1={month1}
                                                    height={400} data={dataToShowForDatesSelected || []}
                                                    selectedMonths={selectedMonths} />}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <Card className="pb-3">
                <CardBody className="">
                    <Row className="show-sales-region">
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="top-location" style={{ minHeight: '400' }}>
                                        <div className="card__title row align-items-center">
                                            <h5 className="bold-text col-md-4">Promotion By Revenue</h5>
                                        </div>
                                        <div >
                                            {isTableLoading ? <div style={{ minHeight: '200px' }}
                                                className="row align-items-center justify-content-center">
                                                <SmallLoader loading={isTableLoading} />
                                            </div>
                                                : <PromotionTable
                                                    dataToShowForDatesSelected={dataToShowForDatesSelected}
                                                    tableHeaderData={tablePromotionByRevenue}
                                                    categorisedBasedOn='promotionId'
                                                />}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            </div>
            {/* <ViewSalesReportModal
          modalData={dataToShowForExcel}
          isOpen={isOpen}
          handleModal={setIsOpen}
          tableHeaderData={tableHeader}
         />  */}
        </Container>
    );
};

PromotionByRevenue.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
}

export default connect(state => ({
    rtl: state.rtl,
}))(PromotionByRevenue);